import type { BoggleRunSummaryTierLevel } from '~/boggle/config/runSummaryScore'

/** Shared Run Summary palette used by both the live summary meter and history rows. */
export const RUN_SUMMARY_TIER_FILL_COLORS: Record<
  BoggleRunSummaryTierLevel | '_none',
  string
> = {
  _none: '#727272',
  I: '#e1dcce',
  II: '#e3d7b5',
  III: '#e4cd8e',
  IV: '#ebc869',
  V: '#f4c136',
}

export function formatRunSummaryMetricValue(categoryId: string, value: number) {
  return categoryId === 'scholar'
    ? (Math.floor(value * 10) / 10).toFixed(1)
    : String(value)
}
